import Byggingen from "./Byggingen";

export default Byggingen;
